// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24URC","rootNoMargin":"styles_rootNoMargin__1fDEI"};